import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useStripeConnect(userId?: string) {
  return useQuery({
    queryKey: ['stripeConnect', userId],
    enabled: !!userId,
    queryFn: async () => {
      // First check if user has phone number in database
      const { data: userData, error: userError } = await supabase
        .from('users')
        .select('phone')
        .eq('id', userId!)
        .single();
      
      if (userError) throw userError;
      
      // Check actual Stripe account status
      const { data, error } = await supabase.functions.invoke('check-stripe-account-status');
      
      if (error) throw error;
      
      return {
        hasStripeAccount: data.hasAccount || false,
        isFullyOnboarded: data.isFullyOnboarded || false,
        canReceivePayments: data.canReceivePayments || false,
        stripeAccountId: data.accountId || null,
        hasPhone: !!userData?.phone,
      };
    },
  });
}